import SectionList from 'components/practice/UserPreferences/components/SectionList';
import Switch from 'components/shared/Switch/Switch';

const StaffStatus = ({ formik }) => {
  return (
    <div>
      <SectionList
        title="Staff member status"
        description="Set whether this staff member is currently active or inactive."
      />

      <div className="flex items-center justify-between rounded-md border border-solid border-neutral-200 px-5 py-3">
        <div>Status</div>
        <Switch
          checked={formik.values.is_active}
          parentContainerClassName="flex items-center w-fit gap-2"
          label={formik.values.is_active ? 'Active' : 'Inactive'}
          onChange={(val) => formik.setFieldValue('is_active', val)}
        />
      </div>
    </div>
  );
};

export default StaffStatus;
